export default __webpack_public_path__ + "static/media/elina@2x.75f16f95.png";